import { render, staticRenderFns } from "./CellRendererFile.vue?vue&type=template&id=20167a14"
import script from "./CellRendererFile.vue?vue&type=script&lang=js"
export * from "./CellRendererFile.vue?vue&type=script&lang=js"
import style0 from "./CellRendererFile.vue?vue&type=style&index=0&id=20167a14&prod&lang=scss&scpoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports